/**
 * Capa de Lógica de Negocio (Business Logic - BL) para la dinámica "Light Show Pro".
 * Gestiona validaciones estructurales (como verificar que existan frames válidos) 
 * y formatea las respuestas para el componente visual del Admin.
 */

import { Prepare as DLPrepare, Start as DLStart, Stop as DLStop } from './../../../DL/Admin/Games/LightShow'

const Prepare = async (beatsPerMinute, framesSequence) => {
    try {
        // 1. Validación de ritmo (BPM)
        if (!beatsPerMinute || beatsPerMinute <= 0) {
            return { success: false, message: "El ritmo (BPM) debe ser mayor a cero." }
        }

        // 2. Validación de la estructura de Frames
        if (!framesSequence || !Array.isArray(framesSequence)) {
            return { success: false, message: "La secuencia de animación es inválida o no existe." }
        }

        if (framesSequence.length < 2) {
            return { success: false, message: "Debes configurar al menos 2 frames (Ej. Uno para encender y otro para apagar) para crear un ciclo." }
        }

        // 3. Todo correcto, enviamos la petición a la capa de datos
        const response = await DLPrepare(beatsPerMinute, framesSequence)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al preparar los frames del show." }
    }
}

// const Start = async () => {
//     try {
//         const response = await DLStart()

//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: "Excepción en la lógica de negocio al intentar iniciar el show." }
//     }
// }

const Start = async (beatsPerMinute, framesSequence) => {
    try {
        if (!beatsPerMinute || beatsPerMinute <= 0) return { success: false, message: "Ritmo inválido." };
        if (!framesSequence || framesSequence.length < 2) return { success: false, message: "Faltan frames." };

        const response = await DLStart(beatsPerMinute, framesSequence);

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al intentar iniciar." }
    }
}

const Stop = async () => {
    try {
        const response = await DLStop()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al intentar detener el show." }
    }
}

export { Prepare, Start, Stop };









// /**
//  * Capa de Lógica de Negocio (Business Logic - BL) para la dinámica "Light Show Pro".
//  * Gestiona validaciones y formatea la respuesta de la capa de datos (DL) para el componente.
//  */

// import { Prepare as DLPrepare, Start as DLStart, Stop as DLStop } from './../../../DL/Admin/Games/LightShow'

// const Prepare = async (beatsPerMinute, backgroundColor) => {
//     try {
//         // Validaciones de negocio simples antes de consumir la API
//         if (!beatsPerMinute || beatsPerMinute <= 0) {
//             return { success: false, message: "Los BPM deben ser mayores a cero." }
//         }

//         if (!backgroundColor || backgroundColor.trim() === '') {
//             return { success: false, message: "Debes seleccionar un color de fondo." }
//         }

//         const response = await DLPrepare(beatsPerMinute, backgroundColor)

//         if (response.success) {
//             // Pasamos la data exitosa al componente
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: "Excepción en la lógica de negocio al preparar." }
//     }
// }

// const Start = async () => {
//     try {
//         const response = await DLStart()

//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: "Excepción en la lógica de negocio al iniciar." }
//     }
// }

// const Stop = async () => {
//     try {
//         const response = await DLStop()

//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: "Excepción en la lógica de negocio al detener." }
//     }
// }

// export { Prepare, Start, Stop };









// import { Prepare as DLPrepare, Start as DLStart, Stop as DLStop } from './../../../DL/Admin/Games/LightShow'


// const Prepare = async () => {
//     try {
//         const response = await DLPrepare()

//         if (response.success) {
//             return { success: true, data: null }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
        
//     }
// }

// const Start = async () => {
//     try {
//         const response = await DLStart()

//         if (response.success) {
//             return { success: true, data: null }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
        
//     }
// }

// const Stop = async () => {
//     try {
//         const response = await DLStop()

//         if (response.success) {
//             return { success: true, data: null }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
        
//     }
// }

// export { Prepare, Start, Stop };